import anime from 'animejs';
import { map } from 'ramda';
import React, { FC, useCallback } from 'react';
import { getScrollParent } from '../../../utils/dom';
import { MediaManagerSDKAnyItem } from '../../../utils/media-manager-sdk';
import { ItemPreview } from '../ItemPreview';
import styles from './ItemsPicker.scss';
import { IOuter } from './ItemsPicker.types';

export const ItemsPicker: FC<IOuter> = ({
  activeItem = {} as MediaManagerSDKAnyItem,
  items,
  setActiveItem,
  dataHook = 'expanded-view-items-picker',
}) => {
  const handleBecomeActive = useCallback((element) => {
    const scrollParent = getScrollParent(element) as HTMLElement;
    const elementMargin = 18;
    const elementLeft: number = element.offsetLeft - scrollParent.offsetLeft;
    const elementWidth: number = element.offsetWidth;
    const elementRight: number = elementLeft + elementWidth;
    const leftBorder: number = scrollParent.scrollLeft;
    const rightBorder: number = leftBorder + scrollParent.offsetWidth;
    const leftDiff: number = elementLeft - leftBorder;
    const rightDiff: number = rightBorder - elementRight;

    if (leftDiff < elementWidth + elementMargin) {
      anime.remove(scrollParent);
      anime({
        targets: scrollParent,
        scrollLeft: `-=${elementWidth + elementMargin * 1.5 - leftDiff}`,
        easing: 'easeInOutCubic',
        duration: 300,
      });
    }

    if (rightDiff < elementWidth + elementMargin) {
      anime.remove(scrollParent);
      anime({
        targets: scrollParent,
        scrollLeft: `+=${elementWidth + elementMargin * 1.5 - rightDiff}`,
        easing: 'easeInOutCubic',
        duration: 300,
      });
    }
  }, []);

  return (
    <div className={styles.itemsPickerWrapper}>
      <div className={styles.itemsPicker} data-hook={dataHook}>
        <div className={styles.itemsWrapper}>
          {map(
            (item) => (
              <ItemPreview
                key={item.id}
                className={styles.itemPreview}
                item={item}
                onClick={setActiveItem}
                onBecomeActive={handleBecomeActive}
                isActive={item === activeItem}
              />
            ),
            items,
          )}
        </div>
      </div>
    </div>
  );
};
